<template>
    <div class="invitation-templates">
        <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
        <el-alert v-if="!supported" title="当前活动的邀请函有固定样式，请沿用原有的上传和姓名设置。" type="info" :closable="false" />
        <div v-if="!error" class="template-cards">
            <div v-for="(item, index) in list" :key="item.url" class="template-card">
                <img :src="item.url" alt="邀请函底图" @click="open(index)" />
                <div class="card-info">
                    <b>邀请函 {{ index + 1 }}</b>
                    <el-tag size="mini" :type="isRegion(item) ? 'success' : 'info'">{{ status(item) }}</el-tag>
                    <div>
                        <el-button type="text" @click="open(index)">{{ supported ? '编辑设置' : '更换底图' }}</el-button>
                        <el-button type="text" class="remove" @click="remove(index)">删除</el-button>
                    </div>
                </div>
            </div>
            <button v-if="list.length < 3" type="button" class="add-template" :disabled="!!error" @click="open(-1)">
                <i class="el-icon-plus" /><span>上传邀请函</span><small>上传底图并设置姓名区域</small>
            </button>
        </div>
        <div class="upload-tip">每个活动最多 3 张，1080 × 1920，JPG / PNG，不超过 4 MB。每张邀请函可单独设置姓名样式。</div>
        <div class="upload-tip">确认设置后，请点击页面“提交 / 修改 / 保存草稿”保存，之后领取的邀请函将使用新样式。</div>
        <a class="design-specification" href="https://admin-1305822803.cos.ap-beijing.myqcloud.com/img/designSpecification.jpeg" target="_blank" rel="noopener">查看邀请函设计规范</a>
        <invitation-layout-dialog :visible.sync="visible" :entries="entries" :initial-index="initialIndex"
            :activity-id="activityId" :supported="supported" :legacy-settings="legacySettings" @confirm="confirm" />
    </div>
</template>

<script>
import InvitationLayoutDialog from './InvitationLayoutDialog.vue';
import { templatePath, legacyConfig } from './invitationLayout';

export default {
    components: { InvitationLayoutDialog },
    props: {
        list: { type: Array, default: () => [] },
        layout: { type: Object, default: null },
        activityId: { type: [String, Number], default: 0 },
        legacySettings: { type: Object, default: () => ({ invitationTemplateType: 1, posterColor: '#ffffff' }) },
        supported: { type: Boolean, default: true },
        error: { type: String, default: '' }
    },
    data() { return { visible: false, initialIndex: -1 }; },
    computed: {
        entries() {
            if (this.error) return [];
            return this.list.map(item => {
                const path = templatePath(item.url);
                const config = this.layout && Array.isArray(this.layout.templates) && this.layout.templates.find(config => config.templatePath === path);
                return { ...item, config: config || legacyConfig(path) };
            });
        }
    },
    methods: {
        isRegion(item) { return this.entries.find(entry => entry.url === item.url).config.mode === 'region'; },
        status(item) {
            const config = this.entries.find(entry => entry.url === item.url).config;
            return config.mode === 'legacy' ? '沿用旧版' : config.enabled ? '已设置' : '不显示姓名';
        },
        open(index) {
            if (this.error) return;
            this.initialIndex = index;
            this.visible = true;
        },
        confirm(entries) {
            this.$emit('change', {
                items: entries.map(({ url, name }) => ({ url, name })),
                layout: { version: 1, templates: entries.map(entry => entry.config) }
            });
            this.visible = false;
        },
        async remove(index) {
            try { await this.$confirm('确定删除这张邀请函及其设置？保存活动后生效。', '删除邀请函', { type: 'warning' }); }
            catch (e) { return; }
            this.confirm(this.entries.filter((entry, i) => i !== index));
        }
    }
};
</script>

<style scoped>
.template-cards { display:flex; gap:16px; flex-wrap:wrap; margin:14px 0; }
.template-card { width:174px; border:1px solid #e5e9ef; border-radius:8px; overflow:hidden; background:#fff; }
.template-card img { display:block; width:100%; height:206px; object-fit:contain; cursor:pointer; background:#f4f6fa; }
.card-info { padding:10px 12px; line-height:26px; }
.card-info b { display:block; color:#303744; }
.remove { color:#f56c6c; }
.add-template { width:174px; min-height:310px; border:1px dashed #b9c5d7; border-radius:8px; color:#5374b8; background:#f8faff; cursor:pointer; }
.add-template i { font-size:30px; }
.add-template span,.add-template small { display:block; margin-top:14px; }
.add-template small { font-size:11px; color:#9097a4; }
.upload-tip { font-size:12px; color:#8b93a3; line-height:23px; }
.design-specification { color:#5374b8; font-size:12px; }
</style>
